import React, { useContext, useEffect, useState } from "react";
import ModalMain from "../../../../components/Modal/ModalMain";
import ModalHeader from "../../../../components/Modal/ModalHeader";

import ModalFooter from "../../../../components/Modal/ModalFooter";
import { t } from "i18next";
import userContext from "../../../../context/users/UserContext";
import toastContext from "../../../../context/toast/ToastContext";
import themeContext from "../../../../context/theme/ThemeContext";
import { TextField } from "@fluentui/react";
import {addTypistStudy} from "../../../../service/StudyListService";
import loaderContext from "../../../../context/loader/LoaderContext";
import { TOAST_TYPE } from "../../../../constants/Constants";
import studylistContext from "../../../../context/studylist/StudylistContext";
const AddStudy = (props) => {
  const {studyData,dataQueryState} = useContext(studylistContext);
  const { roles } = useContext(userContext);
  const {
    showToastv2,
    showProgressToast,
    setProgressList,
    progressList,
    updateProgress,
    hideProgress,
  } = useContext(toastContext);
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const [accessCode , setAccessCode] = useState("");
  
  const handleAddStudy =async ()=>{
    try{
      setLoaderRunning(true);
      ref.current.continuousStart();
      const response = await addTypistStudy(accessCode);
     
      console.log(response);
      if(response.status == 200){
        if(response.data.result == "SUCCESS"){
          showToastv2(TOAST_TYPE.SUCCESS ,response.data.message);
          props.setShowAddStudyModal(false);
          dataQueryState.refetch();
        }else{
          showToastv2(TOAST_TYPE.ERROR ,response.data.message);
        }
        setLoaderRunning(false);
      }else{
        setLoaderRunning(false);
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
        props.setShowAddStudyModal(false);
      }
    }catch(e){
      setLoaderRunning(false);
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));  
      props.setShowAddStudyModal(false);
    }
       
  }

  let DefaultButtonList = [
    {
      title: t("button.close"),
      onclick: () => {
        props.setShowAddStudyModal(false);
      },
    },
  ];

  let PrimaryButtonList = [
    {
      title: "Add Study",
      onclick: ()=>{handleAddStudy()},
    },
  ];

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={t("add-study.title")}
        handleCancel={() => {
          props.setShowAddStudyModal(false);
        }}
      />
    ),
    body: <AddStudyBody accessCode={accessCode} setAccessCode={setAccessCode} />,
    footer: (
      <ModalFooter
        DefaultButtonList={DefaultButtonList}
        PrimaryButtonList={PrimaryButtonList}
      />
    ),
    width: "600px",
  };
  return (
    <>
      {props.showAddStudyModal && (
        <ModalMain
          updatedModal={true}
          modalDetails={modalDetails}
          showModal={props.showAddStudyModal}
        />
      )}
    </>
  );
};

export default AddStudy;

export const AddStudyBody = ({accessCode, setAccessCode}) => {
  const textFieldStyle = {
    fieldGroup: {
      "&.is-disabled": {
        background: "transparent !important",
        border: "1px solid rgba(200, 198, 196, 0.3) !important",
        cursor: "not-allowed",
      },
    },
    root: {
      width: "80%",
      borderRadius: "7px",
      "&.is-disabled": {
        backgroundColor: "transparent !important",
        cursor: "not-allowed",
        border: "none !important",
      },
    },
    field: {
      backgroundColor: "transparent !important",
      border: "1px solid rgba(200, 198, 196, 0.3) !important",
    },
  };
  const { getThemeColor } = useContext(themeContext);
  return (
    <div  style={{ display: "flex", padding: "20px" }}>
      <div style={{ marginRight: "10px" }}>
        <label
          style={{ color: getThemeColor("primary-color") }}
        
        >
          {t("add-study.access-code-title")}
        </label>
      </div>
      <TextField
        className="textArea"
        name="accessCode"
        styles={textFieldStyle}
        placeholder={t("add-study.placeholder-access-code")}
        onChange={(ev,code )=>{setAccessCode(code)}}
        value={accessCode}
        // errorMessage={props.errors.email}
      />
    </div>
  );
};
